import createTypes from 'redux-create-action-types';

export default createTypes(
  // common used
  'GET_SM_LOCATIONS',
  'GET_SM_PROVINCES',
  'GET_SM_CITIES',
  'GET_SM_TAGS',
  'GET_CERTIFICATION_TYPES',
  'CREATE_SM_TAG',
  
  // Supplier
  'GET_SM_SUPPLIER_DETAIL',
  'CREATE_SM_SUPPLIER',
  'UPDATE_SM_SUPPLIER_PROFILE',
  'UPDATE_SM_SUPPLIER_CATEGORY',
  'UPDATE_SM_SUPPLIER_TAG',
  'UPDATE_SM_SUPPLIER_RATING',

  'CREATE_SUPPLIER_INTERNAL_NOTES',
  'GET_SUPPLIER_INTERNAL_NOTES',
  'UPDATE_SUPPLIER_INTERNAL_NOTES',
  'DELETE_SUPPLIER_INTERNAL_NOTES',

  // Factory
  'GET_SM_FACTORY_DETAIL',
  'CREATE_SM_FACTORY'
);
